import axiosInstance from "utils/axiosInstance";
import {appUrls} from "helpers/Urls";

const editAgentProfile = async ({ agentPutData }) => {
    return await axiosInstance.put(appUrls.updateUserProfile, agentPutData);
};
export default editAgentProfile